import { Memo } from '@/hoc/Memo'
import { FC, ReactNode } from 'react'
import { I18nProvider } from './I18nProvider'

interface CoreProviderSchema {
  children: ReactNode
}

export const CoreProvider: FC<CoreProviderSchema> = Memo(
  ({ children }: CoreProviderSchema) => {
    return <I18nProvider>{children}</I18nProvider>
  },
)
